import { Component, Input } from '@angular/core';

import { Router, ActivatedRoute } from '@angular/router';

import { TableBaseComponent } from '../../../../../app/shared/components/tables/table-base/table-base.component';

import { Map } from '../../../../../app/shared/models/map.model';
import { ConfigurationService } from "../../../services/configuration.service";
import { TourTypeUtils } from "../../../utils/tour-type-utils";
import { UserService } from "../../../../core/services/user.service";


@Component({
  selector: 'app-map-table',
  templateUrl: './map-table.component.html'
})
export class MapTableComponent extends TableBaseComponent<Map> {

  @Input() detailLink = '/maps';

  constructor(
    protected router: Router,
    protected route: ActivatedRoute,
    protected config: ConfigurationService,
    protected userService: UserService
  ) {
    super(router, route, config, userService);
  }

  getGlobalFilterFields() {
    this.globalFilters = this.globalFilters || [{
      label: 'ID',
      field: 'id',
      active: this.showId
    }, {
      label: 'Label',
      field:  'label.value',
      active: true
    }];

    return this.globalFilters
      .filter(filter => filter.active)
      .map(filter => filter.field);
  }
}
